import { DeviceConnectionStatus, DeviceConnectionStatusValues, Feature } from '@vi-iot/client';

import { RemoteDeviceType } from '../commissioning';

export enum DeviceTypes {
  EEBus = 'EEBus',
  ElectricityStorage = 'electricityStorage',
  Heating = 'heating',
  Hems = 'hems',
  RoomControl = 'roomControl',
  Tcu = 'tcu',
  ThirdPartyPV = '3rdPartyPV',
  Ventilation = 'ventilation',
  Virtual = 'virtual',
  Vitoconnect = 'vitoconnect',
  UnknownType = 'unknown',
  Zigbee = 'zigbee',
  AirQualitySensor = 'airQualitySensor',
}

export interface GatewayDevice {
  feature?: unknown;
  id: string;
  fingerprint: string;
  modelId: string;
  modelVersion: string;
  name: string;
  roles: string[];
  type: DeviceTypes;
  status: string;
}

export interface GatewayDeviceGroup {
  type: RemoteDeviceType;
  devices: GatewayDevice[];
  feature?: Feature<DeviceConnectionStatus, never>;
}

export interface RemoteDeviceDetails {
  device: GatewayDevice;
  room: string;
  signal: number;
  battery: number;
  heatingCircuit: string;
  connectionStatus: DeviceConnectionStatusValues;
  mountingMode: boolean;
  fhtDemandRelayMode?: string;
  connectionStatusTimestamp?: string;
}

export interface UnassignableDeviceDisconnected {
  isRepeaterDisconnected: boolean;
  isFhtDisconnected: boolean;
}

export interface StatusContent {
  appearedAt: string;
  deviceId: string;
  equipmentType: string;
  errorCode: string;
  errorDescription: string;
  errorEventType: string;
  gatewaySerial: string;
  modelId: string;
  description?: string;
  longDescription?: string;
  title?: string;
}
